
import React from "react";
import MediaTypeDisplay from "./MediaTypeDisplayComponent";
import { MediaAttachment, RootState } from "src/shared/types/src";

export default function TwoAttachments({ media }: { media: MediaAttachment[] }) {
    
    return (
        <div className="d-flex mx-n-4 media-collage-2">
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[0]} collageDisplay={true} largePlayIcon={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[1]} collageDisplay={true} largePlayIcon={true} />
                </div>
            </div>
        </div>
    )
}